const phrase = ["TABI ESSENCE OF STRENGTH", "HONOURING THE PAST", "INSPIRING THE FUTURE"];

function Row() {
  return (
    <div className="flex shrink-0 items-center">
      {[...Array(3)].map((_, r) =>
        phrase.map((p, i) => (
          <span key={`${r}-${i}`} className="flex items-center">
            <span className="whitespace-nowrap px-10 font-serif text-2xl font-light italic tracking-wide text-neutral-600 md:text-4xl">
              {p}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-gold/50" />
          </span>
        ))
      )}
    </div>
  );
}

export default function Marquee() {
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-white/10 py-10 md:py-14">
      <div className="marquee-track">
        <Row />
        <Row />
      </div>
    </div>
  );
}
